export default __webpack_public_path__ + "static/taskdeploy5-1cbad37e33ec1509deee3b5c77f05aaf.png";